var AddCandidatesPageController = /** @class */ (function () {
    /*@ngInject*/
    function AddCandidatesPageController($state, MESSAGECONSTANTS) {
        this.$state = $state;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    AddCandidatesPageController.prototype.$onInit = function () {
        this.$stateParams = this.$transition$.params();
    };
    AddCandidatesPageController.prototype.saveCallback = function () {
        this.$state.go('missioncontrol.candidates');
    };
    return AddCandidatesPageController;
}());
export { AddCandidatesPageController };
AddCandidatesPageController.$inject = ['$state', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './add-candidates-page.html';
import * as TEMPLATE from 'raw-loader!./add-candidates-page.html';
export var AddCandidatesPageComponent = {
    selector: 'addCandidatesPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/addCandidates/add-candidates-page.html',
        controller: AddCandidatesPageController
    }
};
//# sourceMappingURL=add-candidates-page.component.js.map